var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 26,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#005C99",
    strokeWidth: 1.872
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.099 21.972h-25.6c-.863 0-1.563-.7-1.563-1.564V2.5c0-.864.7-1.564 1.564-1.564h25.599c.863 0 1.563.7 1.563 1.564v17.908c0 .864-.7 1.564-1.563 1.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M9.621 18.467V4.44l11.355 7.014z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.313 24.955h13.971"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideo);
export default ForwardRef;